import React from 'react';
import { connect } from 'react-redux';
import FundamentalIndexSummary from '../../../../fundamental/common/index-summary';

class IndexSummary extends React.Component {
  getData = (realTimeData, currentData) => {
    if (Object.keys(realTimeData).length) return realTimeData;
    return currentData;
  };

  render() {
    const { topContentRealTime = {}, topContent = {} } = this.props;
    const data = this.getData(topContentRealTime, topContent);
    return (
      <FundamentalIndexSummary topContent={data} keyToCompare={'TradingDate'} />
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IndexSummary);
